// @ts-check
import React from 'react';
import ReactModal from 'react-modal';

/** @typedef {{
  isOpen: boolean;
  onRequestClose(): void;
  className?: string;
  overlayClassName?: string;
  closeTimeoutMS?: number;
}} ModalProps */

/** @type { React.FC<ModalProps> } */
export const Modal = (props) => {
  const {
    isOpen,
    onRequestClose,
    className = '',
    overlayClassName = '',
    children,
    closeTimeoutMS = 150,
  } = props;

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className={`Modal w-full max-w-lg px-2 focus:outline-none ${className}`}
      overlayClassName={`Overlay ${overlayClassName}`}
      closeTimeoutMS={closeTimeoutMS}
    >
      <div className="bg-white rounded-lg shadow-md">{children}</div>
    </ReactModal>
  );
};
